<template>
  <div class="w-1/4 sm:w-full lg:w-1/2 mb-5 px-3">
    <a
      :href="href"
      class="block bg-white text-center shadow-sm rounded-md px-4 xl:px-2 py-5 min-h-full box-background-wrap"
      target="_blank">
      <div
        class="text-lg lg:text-base font-medium leading-5 font-semibold mt-2 mb-0">
        {{title}}
      </div>
      <span class="text-xs font-light inline-block">{{subTitle}}</span>
    </a>
  </div>
</template>

<script>
export default {
  name: "home-donor-info-card",
  props: {
    href: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      required: true
    },
  }
};
</script>

<style></style>
